import { isPublic, PRODUCT } from '@/utils/environment'
import { getCrossListedProducts } from './compatibility'

export const getPublicAppPath = (app, selectedProduct) => {
  const target =
    selectedProduct && getCrossListedProducts(app).includes(selectedProduct)
      ? selectedProduct
      : app.product
  return isPublic && target === PRODUCT.Text
    ? `https://www.text.com/marketplace/apps/${app.slug}/`
    : `/apps/${app.slug}/`
}
